"use-strict";

class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.getHeightAddToCart();
    const btn_minimal = this.querySelector("minimal-button");
    if (btn_minimal) {
      btn_minimal.addEventListener("click", this.toggle.bind(this), false);
    }
  }
  getHeightAddToCart() {
    const _this = this;
    this.main = this.closest(".sec__featured-product");
    if (!this.main) return;
    const primaryBtn = this.main.querySelector(".button-trigger__sticky");
    const footer = document.querySelector(".product-sticky-hide");

    if (!primaryBtn) return;

    var isVisible = true;
    window.addEventListener("scroll", function () {
      var buttonRect = primaryBtn.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      if (footer) {
        var footerRect = footer.getBoundingClientRect();
        if (footerRect.top < window.innerHeight - 100) {
          _this.classList.remove("show-sticky-cart");
          isVisible = true;
        } else {
          if (
            !isVisible &&
            buttonRect.top < viewportHeight &&
            buttonRect.bottom > 0
          ) {
            isVisible = true;
            _this.classList.remove("show-sticky-cart");
          } else if (isVisible && buttonRect.bottom <= 0) {
            isVisible = false;
            _this.classList.add("show-sticky-cart");
          }
        }
      } else {
        if (
          !isVisible &&
          buttonRect.top < viewportHeight &&
          buttonRect.bottom > 0
        ) {
          isVisible = true;
          _this.classList.remove("show-sticky-cart");
        } else if (isVisible && buttonRect.bottom <= 0) {
          isVisible = false;
          _this.classList.add("show-sticky-cart");
        }
      }
    });
  }
  toggle(e) {
    const target = e.currentTarget;
    target.classList.toggle("opened");
    if (!target) return;
    const parent = target.closest("sticky-add-cart");
    if (!parent) return;
    const content = parent.querySelector(".content--expand");
    slideAnime({
      target: content,
      animeType: "slideToggle",
    });
  }
}
customElements.define("sticky-add-cart", StickyAddCart);
// js for fake sold
class SoldProduct extends HTMLElement {
  constructor() {
    super();
    this.sold = this.dataset.sold;
    this.hours = this.dataset.hours;
    this.message = this.dataset.message;
    this.init();
  }
  init() {
    if (this.message && this.sold && this.hours) {
      var message = "";
      message = this.message
        .replace("{{ sold }}", this.randomSelect(this.sold))
        .replace("{{ hours }}", this.randomSelect(this.hours));
      this.innerHTML += message;
    }
  }

  randomSelect(numbers) {
    const numberArray = numbers.split(",");
    const randomIndex = Math.floor(Math.random() * numberArray.length);
    const randomNumber = numberArray[randomIndex];
    return randomNumber;
  }
}
customElements.define("sold-product", SoldProduct);

// js for live view
class LiveView extends HTMLElement {
  constructor() {
    super();
    this.min = this.dataset.min;
    this.max = this.dataset.max;
    this.interval = this.dataset.interval;
    this.message = this.dataset.message;
    this.init();
  }
  init() {
    if (this.message && this.max && this.min && this.interval) {
      this.handle();
      setInterval(() => {
        this.handle();
      }, this.interval * 1000);
    }
  }

  handle() {
    var message = "";
    message = this.message.replace(
      "[count]",
      this.randomSelect(parseInt(this.min), parseInt(this.max))
    );
    this.innerHTML = message;
  }

  randomSelect(min, max) {
    const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    return randomNumber;
  }
}
customElements.define("live-view", LiveView);



class CompareRadios extends SwatchInit {
  constructor() {
    super();
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.init();
    this.initFunction();
  }

  initFunction() {
    this.querySelectorAll(".product__color-swatches--js").forEach((btn) => {
      btn.addEventListener("click", this.onVariantChange.bind(this), false);
    });
  }

  onVariantChange(e) {
    e.preventDefault();
    const target = e.currentTarget;
    target.classList.toggle("active");
    this.handleWhenSwatchUpdate();
  }

  handleWhenSwatchUpdate() {
    this.updateOptions();
    const arrayItem = this.updateMasterId(this.variantData);
    this.handleMediaCompare(arrayItem);
  }

  handleMediaCompare(arrayItem) {
    if (!arrayItem) return;
    const html = `
            ${arrayItem
              .map((item) => {
                return `
                <div class="compare__items-inner">
                        <img width="300px" height="300px" src="${item.featured_media.preview_image.src}" alt="${item.featured_media.alt}">
                        <p class="mb-0 mt-10 heading-style capitalize">${item.title}</p></div>
                    `;
              })
              .join("")}
        `;
    const compareColorContent = this.closest(".compare-colors__content");
    if (!compareColorContent) return;
    const compareItems = compareColorContent.querySelector(".compare__items");
    if (!compareItems) return;
    compareItems.innerHTML = html;
  }

  updateMasterId(variantData) {
    let arrayItem = [];
    this.options.forEach((option) => {
      const matchingVariant = variantData.find((variant) => {
        return variant.options.includes(option);
      });
      if (matchingVariant) {
        arrayItem.push(matchingVariant);
      }
    });
    return arrayItem;
  }
}
customElements.define("compare-radios", CompareRadios);

class ProductRecommendations extends SlideSection {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          if (recommendations.innerHTML.trim().length === 0) {
            this.remove();
            if (document.querySelector(".product-recommendations-heading")) {
              document
                .querySelector(".product-recommendations-heading")
                .remove();
            }
          }
        })
        .finally(() => {
          if (this.querySelector(".swiper-wrapper")) {
            this.initSlide();
            BlsAnimations.innit();
          }
          initLazyloadItem();
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

// js for live view
class SkeletonPage extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    window.setTimeout(() => {
      this.classList.remove("skeleton");
    }, 1500);
  }
}
customElements.define("skeleton-page", SkeletonPage);

// js for live view
class ProductGrouped extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    var group = this.querySelector('.productGroup[type="application/json"]');
    if (!group) return;
    var variantData = JSON.parse(group.innerText);
    var query = "";
    variantData.forEach((e, key, variantData) => {
      if (!Object.is(variantData.length - 1, key)) {
        query += e + "%20OR%20id:";
      } else {
        query += e;
      }
    });
    var productAjaxURL = "?q=id:" + query + "&section_id=product-grouped";
    fetch(`${window.routes.search_url}${productAjaxURL}`)
      .then((response) => response.text())
      .then(async (responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        this.innerHTML = html.querySelector(".product-group").innerHTML;
      })
      .catch((e) => {
        throw error;
      })
      .finally(() => {
        this.eventProductGroupAction();
      });
  }

  eventProductGroupAction() {
    document
      .querySelectorAll(".product-group-list .product-variant-option")
      .forEach((select) => {
        select.addEventListener(
          "change",
          (event) => {
            var target = event.target;
            var image =
                target.options[target.selectedIndex].getAttribute("data-image"),
              price =
                target.options[target.selectedIndex].getAttribute("data-price"),
              pro_handle = target.getAttribute("data-handle"),
              image =
                target.options[target.selectedIndex].getAttribute("data-image"),
              price =
                target.options[target.selectedIndex].getAttribute("data-price"),
              pro_handle = target.getAttribute("data-handle"),
              compare_price =
                target.options[target.selectedIndex].getAttribute(
                  "data-compare-price"
                );
            var img = target
              .closest(".product-group-list")
              .querySelector(".product-group-item ." + pro_handle + "")
              .querySelector("img");
            if (img) {
              img.removeAttribute("srcset");
              img.setAttribute("src", image);
            }
            const productTarget = target.closest(".product-group-item");
            const bls__price = productTarget.querySelector(
              ".product-item__price .card-product-price"
            );
            if (bls__price) {
              if (!bls__price.querySelector(".compare-price")) {
                var ps = document.createElement("div");
                var sp = document.createElement("span");
                var cp = document.createElement("s");
                cp.classList.add("price-item", "compare-price");
                sp.appendChild(cp);
                ps.appendChild(sp);
                ps.classList.add("price-regular");
                if (productTarget.querySelector(".card-product-price")) {
                  productTarget
                    .querySelector(".card-product-price")
                    .appendChild(ps);
                }
              }
              const cpp = bls__price.querySelector(".compare-price");

              if (cpp) {
                if (compare_price && compare_price > price) {
                  const compare_format = Shopify.formatMoney(
                    compare_price,
                    themeGlobalVariables.settings.money_format
                  );
                  cpp.innerHTML = compare_format;
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.add("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.add("price--special");
                  }
                } else {
                  cpp.innerHTML = "";
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.remove("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price.querySelector(
                      ".price-regular .price"
                    ).innerHTML = Shopify.formatMoney(
                      price,
                      cartStrings.money_format
                    );
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.remove("price--special");
                  }
                }
              }
            }
            target.setAttribute("data-price", price);
            target.setAttribute("data-compare-price", compare_price);
          },
          false
        );
      });

    let totalQty = 0;
    const classQty = document.querySelectorAll(
      ".quantity__input-product-group"
    );
    classQty.forEach((input) => {
      let valueQtyDefault = input.value;
      let valueAsDefault = parseFloat(valueQtyDefault);
      if (!isNaN(valueAsDefault)) {
        totalQty += valueAsDefault;
      }
      input.addEventListener("change", () => {
        totalQty = 0;
        classQty.forEach((value) => {
          let valueQty = value.value;
          let valueAsQty = parseFloat(valueQty);
          if (!isNaN(valueAsQty)) {
            totalQty += valueAsQty;
          }
        });
      });
    });
    document.querySelectorAll(".product-group-submit").forEach((button) => {
      button.addEventListener(
        "click",
        (event) => {
          if (totalQty === 0) {
            const content = document.querySelector(
              ".form-infor .add-cart-error"
            );
            const messageErrQty = button.getAttribute("data-add-cart-err-qty");
            handleErrorMessagePopup(messageErrQty);
            if (!content) return;
          } else {
            this.submitProductGroup(event);
          }
        },
        false
      );
    });

    document.querySelectorAll(".product-group-buy-now").forEach((button) => {
      button.addEventListener(
        "click",
        (event) => {
          if (totalQty === 0) {
            const content = document.querySelector(
              ".form-infor .add-cart-error"
            );
            const messageErrQty = button.getAttribute("data-add-cart-err-qty");
            handleErrorMessagePopup(messageErrQty);
            if (!content) return;
          } else {
            this.submitNowProductGroup(event);
          }
        },
        false
      );
    });
  }

  submitNowProductGroup(event) {
    event.preventDefault();
    const form = document.getElementById("form-product-grouped");
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData(form);
    config.body = formData;
    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (parsedState.items) {
          window.location.href = "/checkout";
        } else {
          const content = document.querySelector(".form-infor .add-cart-error");
          if (!content) return;
        }
      })
      .catch((e) => {
        throw e;
      });
  }

  submitProductGroup(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    const form = document.getElementById("form-product-grouped");
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    let openMiniCart = 0;
    const formData = new FormData(form);
    if (cart) {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
    }
    config.body = formData;
    target.classList.add("loading");
    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        fetch("/cart.json")
          .then((res) => res.json())
          .then((cart) => {
            if (cart.item_count != undefined) {
              document.querySelectorAll(".cart-count").forEach((el) => {
                if (el.classList.contains("cart-count-drawer")) {
                  el.innerHTML = `(${cart.item_count})`;
                } else {
                  el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
                }
              });
              if (document.querySelector("header-total-price")) {
                document.querySelector("header-total-price").updateTotal(cart);
              }
              const cart_free_ship = document.querySelector(
                "free-ship-progress-bar"
              );
              if (cart_free_ship) {
                cart_free_ship.init(cart.items_subtotal_price);
              }
            }
          })
          .catch((error) => {
            throw error;
          });
        const parsedState = JSON.parse(state);
        if (parsedState.message) {
          handleErrorMessagePopup(parsedState.description);
          if (!content) return;
        } else {
          parsedState.items.forEach((e) => {
            if (e.quantity > 0) {
              openMiniCart = 1;
            }
          });
          cart.getSectionsToRender().forEach((section) => {
            const elementToReplace = document.getElementById(section.id);
            const html = new DOMParser().parseFromString(
              parsedState.sections[section.id],
              "text/html"
            );
            elementToReplace.innerHTML =
              html.querySelector("#minicart-form").innerHTML;
            const countdown = cart.querySelector(".cart-countdown-time");
            const html_countdown = html.querySelector(".cart-countdown-time");
            if (countdown && html_countdown) {
              countdown.innerHTML = html_countdown.innerHTML;
            }
          });
          cart.cartAction();
        }
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        target.classList.remove("loading");
        if (openMiniCart === 1) {
          cart.open();
        }
        const cartRecommend = document.querySelector(".cart-recommend");
        if (
          cartRecommend &&
          !cartRecommend.classList.contains("hidden-recommend")
        ) {
          if (cartRecommend.classList.contains('cart-recommend-custom')) {
            const cartUpsellItem = document.querySelectorAll('.cart-upsell-item');
            const cartUpsellSlide = document.querySelectorAll('.swiper-cart-upsell .swiper-slide');
            if (cartUpsellItem.length > 0) {
              setTimeout(function () {
                cartRecommend.classList.add("open");
              }, 800);
            } else if (cartUpsellSlide.length === 0){
              cartRecommend.classList.remove('block');
              cartRecommend.classList.add('hidden');
            }
          }else{
            setTimeout(function () {
              cartRecommend.classList.add("open");
            }, 800);
          }
        }
      });
  }
}
customElements.define("product-group", ProductGrouped);

// js for product addons
class ProductAddons extends PopupBase {
  constructor() {
    super();
    this.productPopupDiv = this.querySelector(".product-addons__content");
    this.init();
  }
  init() {
    if (this.productPopupDiv) {
      this.addEventListener("click", this.onClick.bind(this));
    }
  }
  onClick() {
    const html = this.productPopupDiv;
    if (!html) return;
    html.classList.remove("hidden");
    this.initPopup(
      html,
      `<h3 class="title-popup h5 my-0 px-20 px-md-30 py-20 border-bottom">${this.dataset?.textHeader}</h3>`
    );
  }
}
customElements.define("product-addons", ProductAddons);

class SwatchDropdown extends HTMLElement {
  constructor() {
    super();
    this.spanFor = this.dataset.spanFor;
    this.init();
  }
  init() {
    if (!this.spanFor) return;
    this.addEventListener("click", this.activeFilterSort.bind(this), false);
  }
  activeFilterSort() {
    if (this.querySelector(`#${this.spanFor}`).classList.contains("active")) {
      this.querySelector(`#${this.spanFor}`).classList.remove("active");
    } else {
      this.querySelector(`#${this.spanFor}`).classList.add("active");
    }
  }
}
customElements.define("swatch-dropdown", SwatchDropdown);

class ProductBoughtTogether extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const boughTogether = document.querySelector(
      '.productBoughTogether[type="application/json"]'
    );
    if (!boughTogether) return;
    const variantData = JSON.parse(boughTogether.innerText);
    let query = "";
    variantData.forEach((e, key, variantData) => {
      if (!Object.is(variantData.length - 1, key)) {
        query += e + "%20OR%20id:";
      } else {
        query += e;
      }
    });
    const productAjaxURL =
      "?q=id:" + query + "&section_id=product-bough-together";
    fetch(`${window.routes.search_url}${productAjaxURL}`)
      .then((response) => response.text())
      .then(async (responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        document.getElementById("product-bought-together").innerHTML =
          html.querySelector(".bought-together").innerHTML;
      })
      .catch((e) => {
        throw error;
      })
      .finally(() => {
        this.eventProductBoughTogetherAction();
      });
  }
  eventProductBoughTogetherAction() {
    var _this = this;
    document
      .querySelectorAll(".bought-together-checkbox")
      .forEach((checkbox) => {
        checkbox.addEventListener(
          "change",
          (event) => {
            var target = event.target;
            var total_price = 0,
              total_compare_price = 0,
              save_price = 0,
              price,
              compare_price,
              pro_handle = event.target.getAttribute("data-handle");
            var img = target
              .closest("#product-bought-together")
              .querySelector(".product-bought-image-item." + pro_handle + "");
            if (target.checked) {
              img.classList.add("select");
              target
                .closest(".product-bought-together-item")
                .classList.add("select");
              target
                .closest(".product-bought-together-item")
                .querySelector(".product-variant-option")
                .removeAttribute("disabled");
              target
                .closest(".product-bought-together-item")
                .querySelector(".quantity")
                .removeAttribute("disabled");
            } else {
              img.classList.remove("select");
              target
                .closest(".product-bought-together-item")
                .classList.remove("select");
              target
                .closest(".product-bought-together-item")
                .querySelector(".product-variant-option")
                .setAttribute("disabled", true);
              target
                .closest(".product-bought-together-item")
                .querySelector(".quantity")
                .setAttribute("disabled", true);
            }
            setTimeout(function () {
              var bought_together_select = document.querySelectorAll(
                ".product-bought-together-item.select"
              );
              bought_together_select.forEach((item) => {
                var option = item.querySelector(".product-variant-option");
                price = option.getAttribute("data-price");
                compare_price = option.getAttribute("data-compare-price");
                total_price = total_price + Number(price);
                total_compare_price =
                  total_compare_price + Number(compare_price);
              });
              save_price = total_compare_price - total_price;
              _this.eventProductBoughTogetherUpdatePrice(
                total_price,
                total_compare_price,
                save_price
              );
              if (bought_together_select.length <= 1) {
                document
                  .querySelector(".bought-together-submit")
                  .setAttribute("disabled", true);
              } else {
                document
                  .querySelector(".bought-together-submit")
                  .removeAttribute("disabled");
              }
            }, 50);
          },
          false
        );
      });
    document
      .querySelectorAll("#product-bought-together .product-variant-option")
      .forEach((select) => {
        select.addEventListener(
          "change",
          (event) => {
            var target = event.target;
            var total_price = 0,
              total_compare_price = 0,
              save_price = 0,
              image =
                target.options[target.selectedIndex].getAttribute("data-image"),
              price =
                target.options[target.selectedIndex].getAttribute("data-price"),
              pro_handle = target.getAttribute("data-handle"),
              compare_price =
                target.options[target.selectedIndex].getAttribute(
                  "data-compare-price"
                );
            var img = target
              .closest("#product-bought-together")
              .querySelector(".product-bought-image-item." + pro_handle + "")
              .querySelector("img");
            if (img) {
              img.removeAttribute("srcset");
              img.setAttribute("src", image);
            }
            const productTarget = target.closest(
              ".product-bought-together-item"
            );
            const bls__price = productTarget.querySelector(
              ".product-item__price .card-product-price"
            );
            if (bls__price) {
              if (!bls__price.querySelector(".compare-price")) {
                var ps = document.createElement("div");
                var sp = document.createElement("span");
                var cp = document.createElement("s");
                cp.classList.add("price-item", "compare-price");
                sp.appendChild(cp);
                ps.appendChild(sp);
                ps.classList.add("price-regular");
                if (productTarget.querySelector(".card-product-price")) {
                  productTarget
                    .querySelector(".card-product-price")
                    .appendChild(ps);
                }
              }
              const cpp = bls__price.querySelector(".compare-price");

              if (cpp) {
                if (compare_price && compare_price > price) {
                  const compare_format = Shopify.formatMoney(
                    compare_price,
                    themeGlobalVariables.settings.money_format
                  );
                  cpp.innerHTML = compare_format;
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.add("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.add("price--special");
                  }
                } else {
                  cpp.innerHTML = "";
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.remove("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price.querySelector(
                      ".price-regular .price"
                    ).innerHTML = Shopify.formatMoney(
                      price,
                      cartStrings.money_format
                    );
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.remove("price--special");
                  }
                }
              }
            }
            target.setAttribute("data-price", price);
            target.setAttribute("data-compare-price", compare_price);
            document
              .querySelectorAll(".product-bought-together-item.select")
              .forEach((item) => {
                var option = item.querySelector(".product-variant-option");
                price = option.getAttribute("data-price");
                compare_price = option.getAttribute("data-compare-price");
                total_price = total_price + Number(price);
                total_compare_price =
                  total_compare_price + Number(compare_price);
              });
            save_price = total_compare_price - total_price;
            _this.eventProductBoughTogetherUpdatePrice(
              total_price,
              total_compare_price,
              save_price
            );
          },
          false
        );
      });

    document.querySelectorAll(".bought-together-submit").forEach((button) => {
      button.addEventListener(
        "click",
        this.submitBoughtTogether.bind(this),
        false
      );
    });
  }
  submitBoughtTogether(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    const form = document.getElementById("bought-together-form");
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData(form);
    if (cart) {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
    }
    config.body = formData;
    target.classList.add("loading");
    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        fetch("/cart.json")
          .then((res) => res.json())
          .then((cart) => {
            if (cart.item_count != undefined) {
              document.querySelectorAll(".cart-count").forEach((el) => {
                if (el.classList.contains("cart-count-drawer")) {
                  el.innerHTML = `(${cart.item_count})`;
                } else {
                  el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
                }
              });
              if (document.querySelector("header-total-price")) {
                document.querySelector("header-total-price").updateTotal(cart);
              }
              const cart_free_ship = document.querySelector(
                "free-ship-progress-bar"
              );
              if (cart_free_ship) {
                cart_free_ship.init(cart.items_subtotal_price);
              }
            }
          })
          .catch((error) => {
            throw error;
          });
        const parsedState = JSON.parse(state);
        cart.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id);
          const html = new DOMParser().parseFromString(
            parsedState.sections[section.id],
            "text/html"
          );
          elementToReplace.innerHTML =
            html.querySelector("#minicart-form").innerHTML;
          const countdown = cart.querySelector(".cart-countdown-time");
          const html_countdown = html.querySelector(".cart-countdown-time");
          if (countdown && html_countdown) {
            countdown.innerHTML = html_countdown.innerHTML;
          }
        });
        cart.cartAction();
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        target.classList.remove("loading");
        cart.open();
        const cartRecommend = document.querySelector(".cart-recommend");
        if (
          cartRecommend &&
          !cartRecommend.classList.contains("hidden-recommend")
        ) {
          if (cartRecommend.classList.contains('cart-recommend-custom')) {
            const cartUpsellItem = document.querySelectorAll('.cart-upsell-item');
            const cartUpsellSlide = document.querySelectorAll('.swiper-cart-upsell .swiper-slide');
            if (cartUpsellItem.length > 0) {
              setTimeout(function () {
                cartRecommend.classList.add("open");
              }, 800);
            } else if (cartUpsellSlide.length === 0){
              cartRecommend.classList.remove('block');
              cartRecommend.classList.add('hidden');
            }
          }else{
            setTimeout(function () {
              cartRecommend.classList.add("open");
            }, 800);
          }
        }
      });
  }

  eventProductBoughTogetherUpdatePrice(
    total_price,
    total_compare_price,
    save_price
  ) {
    var total = document.querySelector("#product-bought-together .box-total");
    if (total) {
      total.querySelector(".saved-price .price").innerHTML =
        Shopify.formatMoney(save_price, cartStrings.money_format);
      total.querySelector(".total-price .price__sale .price-item").innerHTML =
        Shopify.formatMoney(total_compare_price, cartStrings.money_format);
      total.querySelector(".total-price .price").innerHTML =
        Shopify.formatMoney(total_price, cartStrings.money_format);
      if (total_compare_price > total_price) {
        total.querySelector(".total-price").classList.add("price--on-sale");
        total
          .querySelector(".total-price .price")
          .classList.add("special-price");
      } else {
        total.querySelector(".total-price").classList.remove("price--on-sale");
        total
          .querySelector(".total-price .price")
          .classList.remove("special-price");
      }
      if (save_price > 1) {
        total.querySelector(".saved-price").classList.remove("hidden");
      } else {
        total.querySelector(".saved-price").classList.add("hidden");
      }
    }
  }
}
customElements.define("product-bought-together", ProductBoughtTogether);

class CustomMeasurementManager {
  constructor() {
    this.modal = document.querySelector("[data-measurement-modal]");
    if (!this.modal) return;
    this.sectionId = this.modal.dataset.section;
    // Try multiple methods to find the product form
    this.form = this.modal.closest("form") || 
                document.querySelector('form[action*="/cart/add"]') ||
                document.querySelector('form[data-type="add-to-cart-form"]') ||
                document.querySelector('product-form form') ||
                this.modal.querySelector("form");
    this.productRoot =
      this.form?.closest(".product-detail__information") || document;
    this.entry = this.form?.querySelector("[data-measurement-entry]");
    this.trigger = this.form?.querySelector("[data-measurement-trigger]");
    this.addButton = this.form?.querySelector('[name="add"]');
    this.addButtonLabel = this.addButton?.querySelector(".btn-label");
    if (this.addButtonLabel) {
      this.addButtonLabel.dataset.defaultText =
        this.addButtonLabel.textContent.trim();
    }
    // Get standard inputs first
    this.standardForm = this.modal.querySelector("[data-standard-form]");
    this.standardInputs = Array.from(
      this.standardForm?.querySelectorAll("[data-measurement-input]") || []
    );
    // Get full form inputs (exclude standard form inputs)
    const fullForm = this.modal.querySelector("[data-full-form]");
    const fullFormInputs = Array.from(
      fullForm?.querySelectorAll("[data-measurement-input]") || []
    );
    // Combine all inputs for the modal (both forms)
    this.inputs = Array.from(
      this.modal.querySelectorAll("[data-measurement-input]")
    );
    this.fitInput = this.modal.querySelector("[data-measurement-fit]");
    this.variantInput = this.modal.querySelector("[data-measurement-variant]");
    this.statusInput = this.modal.querySelector("[data-measurement-status]");
    this.overlay = this.modal.querySelector("[data-measurement-close]");
    this.closeButtons = this.modal.querySelectorAll("[data-measurement-close]");
    this.saveButton = this.modal.querySelector("[data-measurement-save]");
    this.errorText = this.modal.querySelector("[data-measurement-error]");
    this.fitButtons = this.modal.querySelectorAll("[data-fit-select]");
    this.requiredVariants = (this.modal.dataset.customVariant || "")
      .split("|")
      .map((label) => label.trim().toLowerCase())
      .filter(Boolean);
    this.standardVariants = (this.modal.dataset.standardVariant || "")
      .split("|")
      .map((label) => label.trim().toLowerCase())
      .filter(Boolean);
    this.measurementVariantLabel =
      (this.modal.dataset.customVariant || "").trim();
    this.measurementVariantLabelValue = this.measurementVariantLabel
      .replace(/"/g, "'")
      .trim()
      .toLowerCase();
    this.measurementProfile = this.modal.dataset.measurementProfile || "";
    this.defaultMeasurementProfile = this.measurementProfile;
    this.standardForm = this.modal.querySelector("[data-standard-form]");
    this.fullForm = this.modal.querySelector("[data-full-form]");
    this.fullNotes = this.modal.querySelector("[data-full-notes]");
    this.fullGrid = this.fullForm?.querySelector(".custom-measurement-grid");
    this.fullNotesList = this.fullNotes?.querySelector("ol");
    this.variantPicker =
      this.productRoot.querySelector(".product-detail__variant-picker");
    // Requirement sources:
    // - Variant-driven requirement (theme variant picker)
    // - App-driven requirement (Easy Options / Easify)
    this.variantRequires = false;
    this.variantIsStandard = false;
    this.easifyRequires = false;
    this.easifySelectionLabel = "";
    this.activeVariantRequires = false;
    this.isStandardStitching = false;
    this.measurementsSaved = false;
    this.savedVariantId = null;
    this.easifyListenerAttached = false;
    this.easifyObserver = null;
    this.bindEvents();
  }

  bindEvents() {
    if (this.trigger) {
      this.trigger.addEventListener("click", () => this.open());
    }
    this.closeButtons.forEach((button) => {
      button.addEventListener("click", () => this.close());
    });
    if (this.saveButton) {
      this.saveButton.addEventListener("click", () => this.handleSave());
    }
    if (this.form) {
      this.form.addEventListener("submit", (event) =>
        this.handleFormSubmit(event)
      );
    }
    if (this.fitButtons.length && this.fitInput) {
      this.fitButtons.forEach((button) => {
        button.addEventListener("click", () =>
          this.handleFitSelection(button.dataset.fitSelect)
        );
      });
    }
    document.addEventListener("variant:change", (event) =>
      this.handleVariantChange(event)
    );
    this.attachVariantPickerListener();
    // Easy Options / Easify (third-party app) hooks
    // Their script dispatches `easify:loaded` when the option UI is injected.
    document.addEventListener("easify:loaded", () => this.attachEasifyListeners());
    // Also try once in case the app rendered before DOMContentLoaded.
    this.attachEasifyListeners();
    // And keep watching/retrying for late-rendered widgets (often 4-10s).
    this.startEasifyWatcher();
    this.syncFromCurrentVariant();
  }

  startEasifyWatcher() {
    if (this.easifyListenerAttached) return;

    // 1) MutationObserver: attach as soon as the app injects its inputs
    if (!this.easifyObserver && "MutationObserver" in window) {
      this.easifyObserver = new MutationObserver(() => {
        if (this.easifyListenerAttached) {
          this.easifyObserver?.disconnect();
          this.easifyObserver = null;
          return;
        }
        this.attachEasifyListeners();
      });

      try {
        this.easifyObserver.observe(document.documentElement, {
          childList: true,
          subtree: true,
        });
      } catch (e) {
        // ignore observer start failures
      }

      // Safety stop after 30s
      window.setTimeout(() => {
        if (this.easifyObserver && !this.easifyListenerAttached) {
          this.easifyObserver.disconnect();
          this.easifyObserver = null;
        }
      }, 30000);
    }

    // 2) Timed retries: covers cases where mutations are missed
    let attempts = 0;
    const maxAttempts = 20; // ~10s
    const interval = window.setInterval(() => {
      if (this.easifyListenerAttached) {
        window.clearInterval(interval);
        return;
      }
      attempts += 1;
      this.attachEasifyListeners();
      if (attempts >= maxAttempts) {
        window.clearInterval(interval);
      }
    }, 500);
  }

  handleVariantChange(event) {
    const detail = event.detail || {};
    if (detail.sectionId !== this.sectionId) return;
    const shouldPrompt = Boolean(detail.trigger);
    this.applyVariantState(detail.variant, { shouldPrompt });
  }

  syncFromCurrentVariant() {
    if (!this.form) return;
    const variantInput = this.form.querySelector(".product-variant-id");
    if (!variantInput) return;
    const variantId = Number(variantInput.value);
    if (!variantId) return;
    const variantElement =
      document.querySelector(
        `variant-radios-detail[data-section="${this.sectionId}"] [type="application/json"]`
      ) ||
      document.querySelector(
        `variant-group-detail[data-section="${this.sectionId}"] [type="application/json"]`
      );
    if (!variantElement) return;
    try {
      const variants = JSON.parse(variantElement.textContent || "[]");
      const currentVariant = variants.find(
        (variant) => Number(variant.id) === variantId
      );
      this.applyVariantState(currentVariant, { shouldPrompt: false });
    } catch (error) {
      console.error("Unable to parse variant data", error);
    }
  }

  applyVariantState(variant, options = {}) {
    if (!variant) return;
    this.currentVariant = variant;
    this.variantRequires = this.variantMatchesRequirement(variant);
    this.variantIsStandard = this.variantMatchesStandard(variant);
    this.recomputeRequirement({ shouldPrompt: options.shouldPrompt });
    this.toggleFormDisplay();
    this.toggleInputs(this.activeVariantRequires);
    if (this.activeVariantRequires) {
      if (this.savedVariantId !== variant.id) {
        this.measurementsSaved = false;
        this.statusInput && (this.statusInput.value = "");
      }
      this.showEntry();
      if (!this.measurementsSaved && options.shouldPrompt) {
        this.open();
      }
    } else {
      this.hideEntry();
      this.close();
      this.measurementsSaved = false;
      this.savedVariantId = null;
      if (this.statusInput) {
        this.statusInput.value = "";
      }
    }
    this.updateAddButton();
  }

  recomputeRequirement(options = {}) {
    // Combine requirement sources
    this.isStandardStitching = Boolean(this.variantIsStandard);
    this.activeVariantRequires = Boolean(
      this.variantRequires || this.variantIsStandard || this.easifyRequires
    );

    // Populate hidden "Customization Variant" property with something meaningful.
    // Note: Easy Options already creates its own line-item property; this is for your internal tracking.
    if (this.variantInput) {
      if (this.easifySelectionLabel) {
        this.variantInput.value = this.easifySelectionLabel;
      } else if (this.currentVariant?.title) {
        this.variantInput.value = this.currentVariant.title;
      } else {
        this.variantInput.value = "";
      }
    }

    if (this.activeVariantRequires) {
      // If requirement source changed away from the saved state, force re-save
      if (this.easifyRequires && !this.measurementsSaved && options.shouldPrompt) {
        this.open();
      }
    }
  }

  getProfileContent(profile) {
    const common = {
      saree: {
        fields: [
          "Blouse Length (inches)*",
          "Around Bust (inches)*",
          "Around Above Waist (inches)*",
          "Sleeve Length (inches)*",
          "Full Shoulder (inches)*",
          "Front Neck Depth (inches)*",
          "Back Neck Depth (inches)*",
          "Arm Hole (inches)*",
          "Arm Round (inches)*",
          "Apex Point (inches)*",
        ],
        notes: [
          "Please follow the instructions above to get your exact body size and then compare it to our body measurement chart to see which size fits you best",
          "Keep Measurement tape firm, but not tight",
          "Ask someone to assist you while taking measurement",
          "We only stitch upto 42 bust any special requirements to be mailed first",
          "Sleeves length are subjected to change depending on design",
        ],
        extra: {
          closingSideLabel: "Blouse Closing Side *",
          closingSideName: "Blouse Closing Side",
          closingWithLabel: "Blouse Closing With *",
          closingWithName: "Blouse Closing With",
        },
      },
      lehenga: {
        fields: [
          "Choli Length (inches)*",
          "Around Bust (inches)*",
          "Around Above Waist (inches)*",
          "Sleeve Length (inches)*",
          "Full Shoulder (inches)*",
          "Front Neck Depth (inches)*",
          "Back Neck Depth (inches)*",
          "Arm Round (inches)*",
          "Apex Point (inches)*",
          "Around Waist (inches)*",
          "Lehenga Length (inches)*",
          "Around Hip (inches)*",
        ],
        notes: [
          "Please follow the instructions above to get your exact body size and then compare it to our body measurement chart to see which size fits you best",
          "Keep Measurement tape firm, but not tight",
          "Ask someone to assist you while taking measurement",
          "We only stitch upto 42 bust any special requirements to be mailed first",
          "Sleeves length are subjected to change depending on design",
        ],
        extra: {
          closingSideLabel: "Choli Closing Side *",
          closingSideName: "Choli Closing Side",
          closingWithLabel: "Choli Closing With *",
          closingWithName: "Choli Closing With",
        },
      },
      salwar_kameez: {
        fields: [
          "Full Body Height (inches)*",
          "Around Bust (inches)*",
          "Hip Size (inches)*",
          "Sleeve Length (inches)*",
          "Back Neck Depth (inches)*",
          "Apex Point (inches)*",
          "Around Waist (inches)*",
          "Kameez Length (inches)*",
          "Around Above Waist (inches)*",
          "Full Shoulder (inches)*",
          "Front Neck Depth (inches)*",
          "Arm Round (inches)*",
          "Bottom Length (inches)*",
          "Ankle Round (inches)*",
        ],
        notes: [
          "Please follow the instructions above to get your exact body size and then compare it to our body measurement chart to see which size fits you best",
          "Keep Measurement tape firm, but not tight",
          "Ask someone to assist you while taking measurement",
          "We only stitch upto 42 bust any special requirements to be mailed first",
        ],
        extra: {
          closingSideLabel: "Closing Side *",
          closingSideName: "Closing Side",
          closingWithLabel: "Closing With *",
          closingWithName: "Closing With",
          includePocket: true,
        },
      },
      sherwani: {
        fields: [
          "Full Body Height (inches)*",
          "Top Length (inches)*",
          "Around Chest (inches)*",
          "Around Stomach (inches)*",
          "Hip Size (inches)*",
          "Full Shoulder (inches)*",
          "Sleeve Length (inches)*",
          "Around Neck (inches)*",
          "Bottom Length (inches)*",
          "Inside Leg Length (inches)*",
          "Around Waist (inches)*",
          "Around Thigh (inches)*",
          "Around Knee (inches)*",
          "Around Ankle (inches)*",
        ],
        notes: [
          "Measure over light clothing to maintain accuracy",
          "Keep the tape level across the body while measuring chest and hip",
          "Note shoulder width as the straight distance edge-to-edge",
          "Add 0.5 inches of ease if you prefer relaxed fits",
          "Share any special styling notes so the atelier can accommodate them",
        ],
      },
      wedding_suit: {
        fields: [
          "Full Body Height (inches)*",
          "Top Length (inches)*",
          "Around Chest (inches)*",
          "Around Stomach (inches)*",
          "Hip Size (inches)*",
          "Full Shoulder (inches)*",
          "Sleeve Length (inches)*",
          "Around Neck (inches)*",
          "Bottom Length (inches)*",
          "Inside Leg Length (inches)*",
          "Around Waist (inches)*",
          "Around Thigh (inches)*",
          "Around Knee (inches)*",
          "Around Ankle (inches)*",
        ],
        notes: [
          "Measure over a fitted shirt and formal trousers for best wedding suit sizing",
          "Keep the tape level while measuring chest, waist and hip",
          "For sleeve and top length, stand straight with shoulders relaxed",
          "Keep trouser measurements natural without tightening the tape",
          "Share fit preference details in notes if you prefer slim or relaxed finish",
        ],
      },
      indo_western_men: {
        fields: [
          "Full Body Height (inches)*",
          "Top Length (inches)*",
          "Around Chest (inches)*",
          "Around Stomach (inches)*",
          "Hip Size (inches)*",
          "Full Shoulder (inches)*",
          "Sleeve Length (inches)*",
          "Around Neck (inches)*",
          "Bottom Length (inches)*",
          "Inside Leg Length (inches)*",
          "Around Waist (inches)*",
          "Around Thigh (inches)*",
          "Around Knee (inches)*",
          "Around Ankle (inches)*",
        ],
        notes: [
          "Measure over a fitted shirt and trousers for best indowestern sizing",
          "Keep the tape level while measuring chest, waist and hip",
          "For sleeve and top length, stand straight with shoulders relaxed",
          "Keep trouser measurements natural without tightening the tape",
          "Share fit preference details in notes if you prefer slim or relaxed finish",
        ],
      },
      tuxedo_suit: {
        fields: [
          "Full Body Height (inches)*",
          "Top Length (inches)*",
          "Around Chest (inches)*",
          "Around Stomach (inches)*",
          "Hip Size (inches)*",
          "Full Shoulder (inches)*",
          "Sleeve Length (inches)*",
          "Around Neck (inches)*",
          "Bottom Length (inches)*",
          "Inside Leg Length (inches)*",
          "Around Waist (inches)*",
          "Around Thigh (inches)*",
          "Around Knee (inches)*",
          "Around Ankle (inches)*",
        ],
        notes: [
          "Measure over a fitted shirt and formal trousers for best tuxedo sizing",
          "Keep the tape level while measuring chest, waist and hip",
          "For sleeve and top length, stand straight with shoulders relaxed",
          "Keep trouser measurements natural without tightening the tape",
          "Share fit preference details in notes if you prefer slim or relaxed finish",
        ],
      },
      jodhpuri: {
        fields: [
          "Full Body Height (inches)*",
          "Top Length (inches)*",
          "Around Chest (inches)*",
          "Around Stomach (inches)*",
          "Hip Size (inches)*",
          "Full Shoulder (inches)*",
          "Sleeve Length (inches)*",
          "Around Neck (inches)*",
          "Bottom Length (inches)*",
          "Inside Leg Length (inches)*",
          "Around Waist (inches)*",
          "Around Thigh (inches)*",
          "Around Knee (inches)*",
          "Around Ankle (inches)*",
        ],
        notes: [
          "Measure over a fitted shirt and formal trousers for best Jodhpuri sizing",
          "Keep the tape level while measuring chest, waist and hip",
          "For sleeve and top length, stand straight with shoulders relaxed",
          "Keep trouser measurements natural without tightening the tape",
          "Share fit preference details in notes if you prefer slim or relaxed finish",
        ],
      },
    };
    return common[profile] || null;
  }

  renderMeasurementProfile(profile) {
    if (!this.fullGrid || !this.fullNotesList) return;
    const content = this.getProfileContent(profile);
    if (!content) return;

    const renderTextField = (rawLabel) => {
      const isRequired = rawLabel.includes("*");
      const labelText = rawLabel.replace("*", "").trim();
      return `
        <label class="custom-measurement-grid__item">
          <span>${labelText}</span>
          <input
            type="text"
            name="properties[${labelText}]"
            data-measurement-input
            ${isRequired ? 'data-requires-custom="true"' : ""}
            placeholder="Inches"
          >
        </label>
      `;
    };

    const renderRadioGroup = (title, name, options, required) => {
      return `
        <div class="custom-measurement-grid__item custom-measurement-grid__item--full">
          <span>${title}</span>
          <div class="custom-measurement-options">
            ${options
              .map(
                (option) => `
              <label>
                <input
                  type="radio"
                  name="properties[${name}]"
                  value="${option}"
                  data-measurement-input
                  ${required ? 'data-requires-custom="true"' : ""}
                >
                <span>${option}</span>
              </label>
            `
              )
              .join("")}
          </div>
        </div>
      `;
    };

    const fieldsHtml = content.fields.map(renderTextField).join("");
    const pocketHtml = content.extra?.includePocket
      ? renderRadioGroup("One Side Pocket (Optional)", "One Side Pocket", ["Yes", "No"], false)
      : "";

    const extraHtml = content.extra
      ? `
      ${renderRadioGroup(
        content.extra.closingSideLabel,
        content.extra.closingSideName,
        ["Front", "Back", "Side"],
        true
      )}
      ${renderRadioGroup(
        content.extra.closingWithLabel,
        content.extra.closingWithName,
        ["Zip", "Hook"],
        true
      )}
      ${renderRadioGroup("Pads (optional)", "Pads", ["Yes", "No"], false)}
      ${pocketHtml}
      <label class="custom-measurement-grid__item custom-measurement-grid__item--full">
        <span>Comment (optional)</span>
        <textarea
          name="properties[Customization Notes]"
          rows="3"
          data-measurement-input
          placeholder="Share styling notes, closures, cups etc."
        ></textarea>
      </label>
    `
      : `
      <label class="custom-measurement-grid__item custom-measurement-grid__item--full">
        <span>Comment (optional)</span>
        <textarea
          name="properties[Customization Notes]"
          rows="3"
          data-measurement-input
          placeholder="Share styling notes, closures, cups etc."
        ></textarea>
      </label>
    `;

    this.fullGrid.innerHTML = `${fieldsHtml}${extraHtml}`;
    this.fullNotesList.innerHTML = content.notes.map((note) => `<li>${note}</li>`).join("");

    // Re-scan measurement inputs after re-render
    this.inputs = Array.from(this.modal.querySelectorAll("[data-measurement-input]"));
  }

  attachEasifyListeners() {
    if (this.easifyListenerAttached) return;

    // Easy Options / Easify radios are sometimes injected late, and IDs can be duplicated
    // across multiple product widgets. So we:
    // - Scope to THIS product form using the radio's `.form` / `form=""` association.
    // - Detect "custom stitching" by INPUT VALUE (e.g. "Custom Stitching", "Custom Lehenga Stitching").

    const isEasyOptionRadio = (el) => {
      if (!(el instanceof HTMLInputElement)) return false;
      if (el.type !== "radio") return false;
      if (!el.classList.contains("tpo_radio-button")) return false;
      return true;
    };

    const isSameProductForm = (radio) => {
      if (!this.form) return false;
      // If the input is inside the form OR uses `form="..."`, `radio.form` resolves to the associated form.
      if (radio.form && radio.form === this.form) return true;
      const formAttr = radio.getAttribute("form");
      if (formAttr && this.form.id && formAttr === this.form.id) return true;
      if (formAttr) {
        const resolved = document.getElementById(formAttr);
        if (resolved && resolved === this.form) return true;
      }
      return false;
    };

    const isCustomSelectionValue = (value) => {
      const v = String(value || "").toLowerCase();
      // Matches:
      // - "Custom Stitching"
      // - "Custom Lehenga Stitching"
      // - "Custom Blouse Stitching"
      // Avoids standard/unstiched options.
      return v.includes("custom") && v.includes("stitch");
    };

    const resolveProfileFromSelection = (value) => {
      const normalizedValue = String(value || "").toLowerCase();
      if (!isCustomSelectionValue(normalizedValue)) {
        return this.defaultMeasurementProfile;
      }

      // Explicit shared trigger for Tuxedo/Jodhpuri/Wedding Suit family.
      if (normalizedValue.includes("custom wedding suit stitching")) {
        return "wedding_suit";
      }

      const defaultProfile = String(this.defaultMeasurementProfile || "").toLowerCase();
      const isWeddingSuitFamilyDefault = [
        "wedding_suit",
        "tuxedo_suit",
        "jodhpuri",
      ].includes(defaultProfile);

      // Stable category-first mapping:
      // Tuxedo/Jodhpuri/Wedding products always use one common wedding_suit form.
      if (isWeddingSuitFamilyDefault) {
        return "wedding_suit";
      }

      // For other products, then use option text matching.
      if (
        normalizedValue.includes("wedding suit") ||
        normalizedValue.includes("tuxedo") ||
        normalizedValue.includes("jodhpuri")
      ) {
        return "wedding_suit";
      }

      // Must check indo-western before sherwani because option text may contain both.
      if (
        normalizedValue.includes("indowestern") ||
        normalizedValue.includes("indo western")
      ) {
        return "indo_western_men";
      }

      // Men/Wedding Sherwani (ALL):
      // Force Sherwani form when option text references sherwani OR when
      // the product's default profile belongs to sherwani/wedding-sherwani families.
      const isSherwaniFamilyDefault =
        defaultProfile.includes("sherwani");

      if (normalizedValue.includes("sherwani") || isSherwaniFamilyDefault) {
        return "sherwani";
      }
      if (normalizedValue.includes("salwar") || normalizedValue.includes("kameez")) {
        return "salwar_kameez";
      }
      if (normalizedValue.includes("lehenga")) return "lehenga";
      if (normalizedValue.includes("tuxedo")) return "tuxedo_suit";
      if (normalizedValue.includes("jodhpuri")) return "jodhpuri";
      // Keep product category by default for other custom-stitching options.
      return this.defaultMeasurementProfile || "saree";
    };

    const getRadiosForThisForm = () => {
      return Array.from(
        document.querySelectorAll('input.tpo_radio-button[type="radio"]')
      ).filter((r) => isEasyOptionRadio(r) && isSameProductForm(r));
    };

    const getHiddenCustomizationValueForForm = () => {
      if (!this.form) return "";
      // 1) Input inside the form
      let hidden = this.form.querySelector(
        'input[name="properties[Customization options]"]'
      );
      if (hidden?.value) return String(hidden.value);

      // 2) Input outside with form attribute pointing to this form
      if (this.form.id) {
        hidden = document.querySelector(
          `input[name="properties[Customization options]"][form="${this.form.id}"]`
        );
        if (hidden?.value) return String(hidden.value);
      }
      return "";
    };

    const updateFromEasifyAllGroups = (shouldPrompt) => {
      const radios = getRadiosForThisForm();
      if (!radios.length) return;

      // Only evaluate the Easy Options "Customization options" group for this form.
      const customizationRadios = radios.filter((r) =>
        String(r.name || "").toLowerCase().includes("customization options")
      );

      let selectedValue = "";
      // Prefer checked radio (current UI selection), then fallback to hidden property.
      const checkedCustomizationRadio =
        customizationRadios.find((r) => r.checked) ||
        customizationRadios.find((r) => r.classList.contains("tpo_checked"));
      if (checkedCustomizationRadio?.value) {
        selectedValue = String(checkedCustomizationRadio.value);
      } else {
        selectedValue = getHiddenCustomizationValueForForm();
      }

      const requiresByAnyGroup = isCustomSelectionValue(selectedValue);

      const prevRequires = this.activeVariantRequires;
      const prevSelection = this.easifySelectionLabel;

      this.easifyRequires = requiresByAnyGroup;
      this.easifySelectionLabel = selectedValue;
      this.measurementProfile = resolveProfileFromSelection(selectedValue);
      // Apply the selected/default profile to modal fields.
      this.renderMeasurementProfile(this.measurementProfile);

      if (prevSelection && prevSelection !== selectedValue) {
        this.measurementsSaved = false;
        this.savedVariantId = this.currentVariant?.id || null;
        this.statusInput && (this.statusInput.value = "");
      }

      this.recomputeRequirement({
        shouldPrompt: Boolean(shouldPrompt) && this.easifyRequires,
      });
      this.toggleFormDisplay();
      this.toggleInputs(this.activeVariantRequires);

      if (this.activeVariantRequires) {
        this.showEntry();
      } else {
        this.hideEntry();
        this.close();
      }

      if (!prevRequires && this.easifyRequires) {
        this.open();
      }

      this.updateAddButton();
    };

    const applySelectionValue = (rawValue, shouldPrompt) => {
      const selectedValue = String(rawValue || "").trim();
      const prevRequires = this.activeVariantRequires;
      const prevSelection = this.easifySelectionLabel;

      this.easifySelectionLabel = selectedValue;
      this.easifyRequires = isCustomSelectionValue(selectedValue);

      this.measurementProfile = resolveProfileFromSelection(selectedValue);
      this.renderMeasurementProfile(this.measurementProfile);

      if (prevSelection && prevSelection !== selectedValue) {
        this.measurementsSaved = false;
        this.savedVariantId = this.currentVariant?.id || null;
        this.statusInput && (this.statusInput.value = "");
      }

      this.recomputeRequirement({
        shouldPrompt: Boolean(shouldPrompt) && this.easifyRequires,
      });
      this.toggleFormDisplay();
      this.toggleInputs(this.activeVariantRequires);

      if (this.activeVariantRequires) {
        this.showEntry();
      } else {
        this.hideEntry();
        this.close();
      }

      if (!prevRequires && this.easifyRequires) {
        this.open();
      }

      this.updateAddButton();
    };

    const scheduleEasifySync = (shouldPrompt) => {
      // Some Easy Option themes update hidden values asynchronously.
      window.setTimeout(() => updateFromEasifyAllGroups(shouldPrompt), 0);
      window.setTimeout(() => updateFromEasifyAllGroups(shouldPrompt), 120);
    };

    // If the app hasn't rendered for THIS form yet, bail out (watcher will retry)
    const hasAnyEasyOptionsForThisForm = getRadiosForThisForm().length > 0;
    if (!hasAnyEasyOptionsForThisForm) return;

    // Event delegation is the most robust: app can re-render/replace nodes.
    document.addEventListener(
      "click",
      (e) => {
        const target = e.target instanceof Element ? e.target : null;
        if (!target) return;
        // React to any click inside Easy Options wrapper for this page
        if (
          !target.closest(".tpo_option-container") &&
          !target.closest(".tpo_radio-button-wrapper")
        )
          return;
        // Deterministic path: read clicked option value directly.
        const clickedLabel = target.closest("label");
        const clickedRadio =
          clickedLabel?.querySelector?.('input.tpo_radio-button[type="radio"]') ||
          target.closest?.('input.tpo_radio-button[type="radio"]');
        if (isEasyOptionRadio(clickedRadio) && isSameProductForm(clickedRadio)) {
          applySelectionValue(clickedRadio.value, true);
        }
        // Keep fallback sync for async app updates.
        scheduleEasifySync(true);
      },
      true
    );

    document.addEventListener(
      "change",
      (e) => {
        const target = e.target;
        if (!isEasyOptionRadio(target)) return;
        if (!isSameProductForm(target)) return;
        applySelectionValue(target.value, false);
        scheduleEasifySync(false);
      },
      true
    );

    // Initial sync for this form
    scheduleEasifySync(false);

    this.easifyListenerAttached = true;

    // Once attached, we no longer need the DOM observer
    if (this.easifyObserver) {
      this.easifyObserver.disconnect();
      this.easifyObserver = null;
    }
  }

  toggleFormDisplay() {
    const diagramSection = this.modal?.querySelector(".custom-measurement-modal__diagram");
    const isStandardStitchingProfile = this.isStandardStitching && 
      (this.measurementProfile === "salwar_kameez" || this.measurementProfile === "lehenga");
    if (isStandardStitchingProfile) {
      this.standardForm?.removeAttribute("hidden");
      this.fullForm?.setAttribute("hidden", "");
      this.fullNotes?.setAttribute("hidden", "");
      diagramSection?.setAttribute("hidden", "");
    } else {
      this.standardForm?.setAttribute("hidden", "");
      this.fullForm?.removeAttribute("hidden");
      this.fullNotes?.removeAttribute("hidden");
      diagramSection?.removeAttribute("hidden");
    }
  }

  variantMatchesStandard(variant) {
    if (!this.standardVariants.length) return false;
    if (this.measurementProfile !== "salwar_kameez" && this.measurementProfile !== "lehenga") return false;
    const variantValues = [];
    if (variant.title) {
      variantValues.push(variant.title.toLowerCase());
    }
    if (Array.isArray(variant.options)) {
      variant.options.forEach((value) => {
        if (value) variantValues.push(value.toLowerCase());
      });
    }
    return variantValues.some((value) =>
      this.standardVariants.some((standard) => value.includes(standard))
    );
  }

  variantMatchesRequirement(variant) {
    if (!this.requiredVariants.length) return false;
    const variantValues = [];
    if (variant.title) {
      variantValues.push(variant.title.toLowerCase());
    }
    if (Array.isArray(variant.options)) {
      variant.options.forEach((value) => {
        if (value) variantValues.push(value.toLowerCase());
      });
    }
    return variantValues.some((value) =>
      this.requiredVariants.some((required) => value.includes(required))
    );
  }

  toggleInputs(shouldEnable) {
    const activeInputs =
      this.isStandardStitching && (this.measurementProfile === "salwar_kameez" || this.measurementProfile === "lehenga")
        ? this.standardInputs
        : this.inputs;
    const controlled = [
      ...activeInputs,
      this.fitInput,
      this.variantInput,
      this.statusInput,
    ].filter(Boolean);
    controlled.forEach((input) => {
      input.disabled = !shouldEnable;
      if (input.dataset?.requiresCustom === "true") {
        input.required = shouldEnable;
      }
      if (!shouldEnable) {
        input.classList.remove("has-error");
      }
    });
  }

  showEntry() {
    this.entry?.removeAttribute("hidden");
  }

  hideEntry() {
    this.entry?.setAttribute("hidden", "");
  }

  open() {
    this.modal?.removeAttribute("hidden");
    document.documentElement.classList.add("custom-measurement-open");
    const activeInputs =
      this.isStandardStitching && (this.measurementProfile === "salwar_kameez" || this.measurementProfile === "lehenga")
        ? this.standardInputs
        : this.inputs;
    const firstField = activeInputs.find(
      (input) => input.offsetParent !== null && !input.disabled
    );
    firstField?.focus();
  }

  close() {
    this.modal?.setAttribute("hidden", "");
    document.documentElement.classList.remove("custom-measurement-open");
    this.clearValidation();
  }

  handleSave() {
    this.clearValidation();
    if (!this.validateInputs()) {
      this.showError();
      return;
    }
    this.hideError();
    this.measurementsSaved = true;
    if (this.statusInput) {
      this.statusInput.value = "Complete";
    }
    this.savedVariantId = this.currentVariant?.id || null;
    this.updateAddButton();
    this.close();
  }

  validateInputs() {
    if (!this.activeVariantRequires) return true;
    const activeInputs = this.isStandardStitching && (this.measurementProfile === "salwar_kameez" || this.measurementProfile === "lehenga")
      ? this.standardInputs
      : this.inputs;
    let isValid = true;
    const processedRadioGroups = new Set();
    
    activeInputs.forEach((input) => {
      // Skip disabled or hidden inputs
      if (input.disabled || input.offsetParent === null) return;
      
      // Check if this input is required
      const isRequired = input.dataset.requiresCustom === "true" || 
                         input.hasAttribute("data-requires-custom") ||
                         (input.getAttribute("data-requires-custom") === "true");
      
      if (!isRequired) return;
      
      let hasValue = false;
      
      if (input.type === "radio") {
        // For radio buttons, check if any in the group is checked
        const radioName = input.name;
        if (!processedRadioGroups.has(radioName)) {
          processedRadioGroups.add(radioName);
          // Find the form - try multiple methods
          const form = this.form || 
                       input.closest("form") || 
                       document.querySelector('form[action*="/cart/add"]') ||
                       this.modal?.closest("form");
          
          if (form) {
            const checkedRadio = form.querySelector(`input[name="${radioName}"]:checked`);
            hasValue = Boolean(checkedRadio && checkedRadio.value);
            
            if (!hasValue) {
              isValid = false;
              const radios = form.querySelectorAll(`input[name="${radioName}"]`);
              radios.forEach((radio) => {
                const label = radio.closest("label");
                if (label) {
                  label.classList.add("has-error");
                }
              });
            }
          }
        }
      } else {
        // For text inputs, selects, textareas
        const value = input.value ? input.value.trim() : "";
        hasValue = value.length > 0;
        
        if (!hasValue) {
          isValid = false;
          input.classList.add("has-error");
        }
      }
    });
    
    return isValid;
  }

  clearValidation() {
    this.hideError();
    [...this.inputs, ...this.standardInputs].forEach((input) =>
      input.classList.remove("has-error")
    );
    this.form
      ?.querySelectorAll(".custom-measurement-options label.has-error")
      .forEach((label) => label.classList.remove("has-error"));
  }

  handleFitSelection(value) {
    if (!value || !this.fitInput) return;
    this.fitButtons.forEach((button) => {
      button.classList.toggle("is-active", button.dataset.fitSelect === value);
    });
    const fitDescriptions = {
      body: "Body Fit: we will keep 1-inch loosening with 2-inches margins on both sides.",
      garment:
        "Garment Fit: we shall not keep any loosening; 2-inches margins will still be added on both sides.",
    };

    this.fitInput.value =
      value === "garment" ? fitDescriptions.garment : fitDescriptions.body;
    this.toggleFitDescription(value);
  }

  toggleFitDescription(value) {
    const descriptions = this.modal.querySelectorAll(
      "[data-fit-description]"
    );
    descriptions.forEach((desc) => {
      const isTarget = desc.dataset.fitDescription === value;
      desc.toggleAttribute("hidden", !isTarget);
    });
  }

  showError() {
    this.errorText?.removeAttribute("hidden");
  }

  hideError() {
    this.errorText?.setAttribute("hidden", "");
  }

  handleFormSubmit(event) {
    if (!this.activeVariantRequires) return;
    if (this.measurementsSaved) return;
    event.preventDefault();
    event.stopPropagation();
    this.showError();
    this.open();
  }

  attachVariantPickerListener() {
    if (!this.variantPicker) return;
    this.variantPicker.addEventListener(
      "click",
      (event) => {
        if (!this.activeVariantRequires || this.measurementsSaved) return;
        if (!this.measurementVariantLabelValue) return;
        const target = event.target;
        if (!target) return;
        if (!this.variantPicker.contains(target)) return;
        const swatch = target.closest("[data-value]");
        if (swatch?.dataset?.value) {
          const swatchValue = swatch.dataset.value.toLowerCase();
          if (swatchValue === this.measurementVariantLabelValue) {
            this.open();
            return;
          }
        }
        const label = target.closest("label");
        if (label) {
          const text = label.textContent?.trim().toLowerCase();
          if (text && text.includes(this.measurementVariantLabel.toLowerCase())) {
            this.open();
          }
        }
      },
      true
    );
  }

  updateAddButton() {
    if (!this.addButton || !this.addButtonLabel) return;
    const defaultLabel =
      this.addButtonLabel.dataset.defaultText ||
      window.variantStrings?.addToCart ||
      "Add to cart";

    // Respect variant availability if we know it
    const variantUnavailable =
      this.currentVariant && this.currentVariant.available === false;

    if (this.activeVariantRequires && !this.measurementsSaved) {
      this.addButton.setAttribute("disabled", "disabled");
      this.addButtonLabel.textContent =
        window.variantStrings?.measurementsRequired ||
        "Fill measurements to continue";
    } else {
      // Only re-enable if the variant is available; otherwise leave other theme logic in control.
      if (!variantUnavailable) {
        this.addButton.removeAttribute("disabled");
        this.addButtonLabel.textContent = defaultLabel;
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new CustomMeasurementManager();
});

document.addEventListener("DOMContentLoaded", function () {
  function addProductEntry(productJson, storedProducts) {
    if (storedProducts === null) storedProducts = [];

    var currentProductID = productJson.id.toString();
    if (!storedProducts.includes(currentProductID)) {
      storedProducts.unshift(currentProductID);
      if (storedProducts.length > 25) {
        storedProducts.pop();
      }
      localStorage.setItem(
        "milano__recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    } else {
      const index = storedProducts.indexOf(currentProductID);
      if (index > -1) {
        storedProducts.splice(index, 1);
      }
      storedProducts.unshift(currentProductID);
      localStorage.setItem(
        "milano__recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    }
  }

  const prodData = document.querySelector("[data-product-json]");
  if (prodData != null) {
    var productJson = JSON.parse(prodData.innerHTML);
    var storedProducts = JSON.parse(
      localStorage.getItem("milano__recently-viewed-products")
    );
    addProductEntry(productJson, storedProducts);
  }
});
var BlsDropDownProduct = (function () {
  return {
    innit: function () {
      var custom_select = document.querySelectorAll(".custom-select");
      if (custom_select) {
        custom_select.forEach((item) => {
          let select__selected = item.querySelector(".select__selected");
          select__selected.addEventListener("click", (e) => {
            let dropdown = e.target.nextElementSibling;
            dropdown.classList.toggle("hidden");
          });
        });
      }
      document.addEventListener("click", function (event) {
        if (!event.target.closest(".custom-select")) {
          document.querySelectorAll(".select__dropdown")?.forEach((item) => {
            item.classList.add("hidden");
          });
        }
      });
    },
  };
})();

BlsDropDownProduct.innit();

var SyncQuantityInput = (() => {
  return {
    init: () => {
      const syncInputs = document.querySelectorAll(
        ".product-detail__buy-buttons input.quantity-input"
      );
      syncInputs.forEach((input) => {
        input.addEventListener("change", function () {
          const value = this.value;
          syncInputs.forEach((otherInput) => {
            if (otherInput !== input) {
              otherInput.value = value;
            }
          });
        });
      });
    },
  };
})();

SyncQuantityInput.init();

class SlideSectionProductSet extends HTMLElement {
  constructor() {
    super();
    this.globalSlide = null;
    this.init();
  }

  init() {
    if (document.body.classList.contains("index")) {
      let pos = window.pageYOffset;
      if (pos > 0 || document.body.classList.contains("swiper-lazy")) {
        this.initSlide();
      } else {
        if (this.classList.contains("lazy-loading-swiper-before")) {
          this.initSlide();
        } else {
          this.classList.add("lazy-loading-swiper-after");
        }
      }
    } else {
      this.initSlide();
    }
  }

  initSlide() {
    const _this = this;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const autoItem = _this?.dataset.itemMobile === "true";
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    this.globalSlide = new Swiper(_this, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: _this.querySelector(".swiper-button-next"),
        prevEl: _this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el: document.querySelector(".swiper-pagination-product-set"),
        type: "custom",
        renderCustom: function (swiper, current, total) {
          return current + "/" + total;
        }
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
        },
      },

      on: {
        init: function () {
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
        }
      },
    });
  }
}
customElements.define("slide-section-product-set", SlideSectionProductSet);

// Product Accessories Price Manager
class ProductAccessoriesManager {
  constructor() {
    this.accessoriesContainer = document.querySelector("[data-product-accessories]");
    if (!this.accessoriesContainer) return;
    this.checkboxes = this.accessoriesContainer.querySelectorAll(
      ".product-accessories__checkbox"
    );
    this.selects = this.accessoriesContainer.querySelectorAll(
      "[data-accessory-select]"
    );
    
    // Try multiple ways to find the form
    // First try closest form
    this.form = this.accessoriesContainer.closest("form");
    
    // If not found, try to find the product form by various selectors
    if (!this.form) {
      this.form = document.querySelector('form[action*="/cart/add"]') ||
                  document.querySelector('form[data-type="add-to-cart-form"]') ||
                  document.querySelector('#product-form-main-product') ||
                  document.querySelector('product-form form') ||
                  document.querySelector('.product-form form');
    }
    
    // If still not found, try to find through product-form custom element
    if (!this.form) {
      const productFormElement = document.querySelector("product-form");
      if (productFormElement) {
        this.form = productFormElement.querySelector("form") || productFormElement.form;
      }
    }
    
    if (!this.form) {
      console.error("ProductAccessoriesManager: Could not find product form. Accessories container:", this.accessoriesContainer);
      console.error("Available forms:", document.querySelectorAll("form"));
      return;
    }
    
    console.log("ProductAccessoriesManager: Form found:", this.form);
    
    this.basePrice = 0;
    this.originalPriceElements = new Map();
    this.init();
  }

  init() {
    if (!this.form) {
      console.error("ProductAccessoriesManager: Cannot initialize without form");
      return;
    }
    
    this.storeOriginalPrices();
    
    // Create hidden inputs for all accessories upfront
    this.createHiddenInputs();
    
    // Set base price and update display
    this.updateBasePrice();
    
    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        this.updateAccessoryProperty(checkbox);
        this.updatePrice();
      });
    });
    
    // Add event listeners for select dropdowns
    console.log("ProductAccessoriesManager: Found selects:", this.selects.length);
    this.selects.forEach((select) => {
      console.log("ProductAccessoriesManager: Setting up select:", select.name);
      select.addEventListener("change", () => {
        const selectedOption = select.options[select.selectedIndex];
        console.log("ProductAccessoriesManager: Select changed:", select.name, "Value:", selectedOption?.value, "Text:", selectedOption?.textContent);
        this.updateAccessoryPropertyForSelect(select);
        this.updatePrice();
      });
      // Create hidden input for select
      this.createHiddenInputsForSelect(select);
      // If select already has a value, update price immediately
      if (select.value) {
        this.updateAccessoryPropertyForSelect(select);
      }
    });
    
    // Handle form submission - intercept to add accessories as separate line items
    // Use capture phase to run before other handlers
    this.form.addEventListener("submit", (e) => {
      const accessories = this.collectAccessories();
      if (accessories.length > 0) {
        // Prevent default and handle submission manually to add accessories as line items
        e.preventDefault();
        e.stopPropagation();
        this.submitMainProductAndAddAccessories(accessories);
      } else {
        // No accessories, proceed normally
        this.ensurePropertiesInForm(e);
      }
    }, true);
    
    document.addEventListener("variant:change", () => {
      this.updateBasePrice();
    });
    
    // Also update price on initial load after a short delay to ensure variant is loaded
    setTimeout(() => {
      this.updateBasePrice();
      // Also check if any selects have pre-selected values
      this.selects.forEach((select) => {
        if (select.value) {
          this.updateAccessoryPropertyForSelect(select);
        }
      });
      this.updatePrice();
    }, 300);
  }

  updateBasePrice() {
    this.basePrice = this.getBasePrice();
    this.updatePrice();
  }

  createHiddenInputs() {
    // Create hidden inputs for all accessories (they'll be enabled/disabled based on checkbox state)
    this.checkboxes.forEach((checkbox) => {
      this.createHiddenInputsForAccessory(checkbox);
      // Enable them if checkbox is already checked
      if (checkbox.checked) {
        const accessoryInputs = this.form?.querySelectorAll(
          `input[data-accessory-checkbox="${checkbox.value}"]`
        );
        if (accessoryInputs) {
          accessoryInputs.forEach((input) => {
            input.disabled = false;
          });
        }
      }
    });
  }

  collectAccessories() {
    const accessories = [];
    
    // Collect from checkboxes
    this.checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        const accessoryText = checkbox.dataset.accessoryText || checkbox.value;
        const price = this.parsePriceFromText(accessoryText);
        if (price > 0) {
          accessories.push({
            name: accessoryText,
            price: price,
            type: 'checkbox'
          });
        }
      }
    });
    
    // Collect from selects
    this.selects.forEach((select) => {
      const selectedOption = select.options[select.selectedIndex];
      if (selectedOption && selectedOption.value) {
        const accessoryText = selectedOption.textContent?.trim() || 
                             selectedOption.dataset.accessoryText || 
                             selectedOption.value;
        const price = this.parsePriceFromText(accessoryText);
        if (price > 0) {
          const selectName = select.name.replace(/^properties\[|\]$/g, '');
          accessories.push({
            name: selectName,
            value: accessoryText,
            price: price,
            type: 'select'
          });
        }
      }
    });
    
    return accessories;
  }

  async submitMainProductAndAddAccessories(accessories) {
    const form = this.form;
    const submitButton = form.querySelector('[type="submit"], [name="add"]');
    
    // Disable submit button
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.classList.add('loading');
    }
    
    try {
      // First, ensure properties are set
      this.ensurePropertiesInForm(new Event('submit'));
      
      // Submit main product form using the theme's standard method
      const formData = new FormData(form);
      const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      
      if (cart && cart.getSectionsToRender) {
        formData.append('sections', JSON.stringify(cart.getSectionsToRender().map(section => section.id)));
        formData.append('sections_url', window.location.pathname);
      }
      
      // Use the theme's cart add URL
      const cartAddUrl = window.routes?.cart_add_url || '/cart/add';
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
      
      // Check if response is JSON or HTML
      const contentType = response.headers.get('content-type');
      let result;
      
      if (contentType && contentType.includes('application/json')) {
        result = await response.json();
      } else {
        // If HTML response, product was added successfully (Shopify redirects)
        result = { success: true };
      }
      
      if (result.status) {
        // Error adding product
        console.error("Error adding product to cart:", result);
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove('loading');
        }
        return;
      }
      
      // Product added successfully, now add accessories as separate line items
      await this.addAccessoriesAsLineItems(accessories);
      
      // Trigger cart update events
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
      // Refresh cart or redirect
      if (cart && cart.open) {
        // Reload cart sections
        if (cart.getSectionsToRender) {
          const sections = cart.getSectionsToRender().map(section => section.id);
          fetch(`${window.routes?.cart_url || '/cart'}.js`)
            .then(res => res.json())
            .then(cartData => {
              cart.renderContents(cartData);
              cart.open();
            });
        } else {
          cart.open();
        }
      } else {
        // Redirect to cart page
        window.location.href = window.routes?.cart_url || '/cart';
      }
      
    } catch (error) {
      console.error("Error submitting form:", error);
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.classList.remove('loading');
      }
      // Fallback: let form submit normally
      form.submit();
    }
  }

  async addAccessoriesAsLineItems(accessories) {
    // IMPORTANT: To make checkout show correct prices, you need to create products for accessories
    // Option 1: Create a generic "Accessory" product with variants for each price
    // Option 2: Create individual products for each accessory with their prices
    
    // Get accessory product ID from theme settings
    // The user needs to create an "Accessory" product in Shopify and set its variant ID in theme settings
    const accessoryProductId = window.themeGlobalVariables?.settings?.accessory_product_id || 
                               document.querySelector('[data-accessory-product-id]')?.dataset.accessoryProductId;
    
    if (!accessoryProductId) {
      console.warn("ProductAccessoriesManager: No accessory product ID configured. Accessories will be added as properties only.");
      console.warn("To fix checkout prices, create an 'Accessory' product in Shopify and set its variant ID in theme settings.");
      return;
    }
    
    for (const accessory of accessories) {
      try {
        // Add accessory as separate line item
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: accessoryProductId,
            quantity: 1,
            properties: {
              [accessory.name]: accessory.value || accessory.name,
              '_Accessory Price': (accessory.price / 100).toFixed(2),
              '_Original Name': accessory.value || accessory.name
            }
          })
        });
        
        if (!response.ok) {
          const errorText = await response.text();
          console.error(`Error adding accessory ${accessory.name}:`, errorText);
        } else {
          const result = await response.json();
          console.log(`Added accessory ${accessory.name} as line item:`, result);
        }
      } catch (error) {
        console.error(`Error adding accessory ${accessory.name}:`, error);
      }
    }
  }

  ensurePropertiesInForm(event) {
    // Update price before submission
    this.updatePrice();
    
    // Ensure all hidden inputs are enabled/disabled based on checkbox state
    this.checkboxes.forEach((checkbox) => {
      this.updateAccessoryProperty(checkbox);
    });
    
    // Ensure all hidden inputs are updated based on select state
    this.selects.forEach((select) => {
      this.updateAccessoryPropertyForSelect(select);
    });
    
    // Debug: log what's being submitted
    const selectedAccessories = [];
    this.checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        selectedAccessories.push(checkbox.dataset.accessoryText || checkbox.value);
      }
    });
    
    this.selects.forEach((select) => {
      const selectedOption = select.options[select.selectedIndex];
      if (selectedOption && selectedOption.value) {
        const accessoryText = selectedOption.textContent?.trim() || 
                             selectedOption.dataset.accessoryText || 
                             selectedOption.value;
        selectedAccessories.push(accessoryText);
      }
    });
    
    if (selectedAccessories.length > 0) {
      console.log("Selected accessories being added to cart:", selectedAccessories);
    }
  }

  addPropertiesToFormData(formData) {
    // Add all selected accessories to FormData (price is already included in accessory name)
    this.checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        const accessoryText = checkbox.dataset.accessoryText || checkbox.value;
        // Add the accessory property (price is already in the name)
        formData.append(`properties[${accessoryText}]`, accessoryText);
      }
    });
  }

  updateAccessoryProperty(checkbox) {
    if (!this.form) {
      console.error("ProductAccessoriesManager: Form not found, cannot update accessory property");
      return;
    }
    
    const accessoryText = checkbox.dataset.accessoryText || checkbox.value;
    
    // Find the hidden inputs for this accessory
    const accessoryInputs = this.form.querySelectorAll(
      `input[data-accessory-checkbox="${checkbox.value}"]`
    );
    
    if (accessoryInputs && accessoryInputs.length > 0) {
      if (checkbox.checked) {
        // Enable inputs when checked (they're already in the form)
        accessoryInputs.forEach((input) => {
          input.disabled = false;
        });
      } else {
        // Remove inputs when unchecked (disabled inputs aren't included in FormData)
        accessoryInputs.forEach((input) => {
          input.remove();
        });
        // Recreate them disabled so they're ready for next time
        this.createHiddenInputsForAccessory(checkbox);
      }
    } else if (checkbox.checked) {
      // If inputs don't exist and checkbox is checked, create them
      this.createHiddenInputsForAccessory(checkbox);
      // Enable them immediately
      const newInputs = this.form.querySelectorAll(
        `input[data-accessory-checkbox="${checkbox.value}"]`
      );
      newInputs.forEach((input) => {
        input.disabled = false;
      });
    }
  }

  createHiddenInputsForAccessory(checkbox) {
    if (!this.form) {
      console.error("ProductAccessoriesManager: Form not found, cannot create hidden inputs");
      return;
    }
    
    const accessoryText = checkbox.dataset.accessoryText || checkbox.value;
    
    // Create accessory property input (price is already included in the accessory name)
    const accessoryInput = document.createElement("input");
    accessoryInput.type = "hidden";
    accessoryInput.name = `properties[${accessoryText}]`;
    accessoryInput.value = accessoryText;
    accessoryInput.disabled = true; // Will be enabled when checked
    accessoryInput.setAttribute("data-accessory-hidden", "true");
    accessoryInput.setAttribute("data-accessory-checkbox", checkbox.value);
    this.form.appendChild(accessoryInput);
  }

  createHiddenInputsForSelect(select) {
    if (!this.form) {
      console.error("ProductAccessoriesManager: Form not found, cannot create hidden inputs for select");
      return;
    }
    
    const selectName = select.name || select.dataset.accessoryText || "Accessory";
    // Remove "properties[" and "]" from name if present
    const cleanName = selectName.replace(/^properties\[|\]$/g, '');
    
    // Check if hidden input already exists
    let hiddenInput = this.form.querySelector(`input[name="properties[${cleanName}]"][data-accessory-select]`);
    
    if (!hiddenInput) {
      hiddenInput = document.createElement("input");
      hiddenInput.type = "hidden";
      hiddenInput.name = `properties[${cleanName}]`;
      hiddenInput.value = "";
      hiddenInput.disabled = true;
      hiddenInput.setAttribute("data-accessory-hidden", "true");
      hiddenInput.setAttribute("data-accessory-select", select.name || select.dataset.accessoryText);
      this.form.appendChild(hiddenInput);
    }
  }

  updateAccessoryPropertyForSelect(select) {
    if (!this.form) {
      console.error("ProductAccessoriesManager: Form not found, cannot update select property");
      return;
    }
    
    const selectName = select.name || select.dataset.accessoryText || "Accessory";
    const cleanName = selectName.replace(/^properties\[|\]$/g, '');
    const selectedOption = select.options[select.selectedIndex];
    
    // Get the full text from the option (includes price), fallback to value
    const selectedValue = selectedOption ? 
      (selectedOption.textContent?.trim() || selectedOption.dataset.accessoryText || selectedOption.value) : "";
    
    // Find or create hidden input
    let hiddenInput = this.form.querySelector(`input[name="properties[${cleanName}]"][data-accessory-select]`);
    
    if (!hiddenInput) {
      this.createHiddenInputsForSelect(select);
      hiddenInput = this.form.querySelector(`input[name="properties[${cleanName}]"][data-accessory-select]`);
    }
    
    if (hiddenInput) {
      if (selectedValue) {
        hiddenInput.value = selectedValue;
        hiddenInput.disabled = false;
        console.log(`Updated property "${cleanName}" with value: "${selectedValue}"`);
      } else {
        hiddenInput.value = "";
        hiddenInput.disabled = true;
      }
    }
  }

  storeOriginalPrices() {
    const priceElements = document.querySelectorAll(
      ".product-detail__price .card-product-price .price, .price-regular .price"
    );
    priceElements.forEach((element) => {
      if (!this.originalPriceElements.has(element)) {
        this.originalPriceElements.set(element, element.textContent);
      }
    });
  }

  getBasePrice() {
    // Try to get price from variant radios first
    const variantRadios = document.querySelector("variant-radios-detail");
    if (variantRadios && variantRadios.currentVariant) {
      const price = variantRadios.currentVariant.price || 0;
      if (price > 0) {
        console.log("Base price from variantRadios:", price);
        return price;
      }
    }
    
    // Try to get from variant input
    const variantInput = document.querySelector(".product-variant-id");
    if (variantInput && variantInput.value) {
      const variantId = parseInt(variantInput.value);
      const variantElement =
        document.querySelector(
          `variant-radios-detail[data-section] [type="application/json"]`
        ) ||
        document.querySelector(
          `variant-group-detail[data-section] [type="application/json"]`
        );
      if (variantElement) {
        try {
          const variants = JSON.parse(variantElement.textContent || "[]");
          const variant = variants.find((v) => Number(v.id) === variantId);
          const price = variant?.price || 0;
          if (price > 0) {
            console.log("Base price from variant data:", price);
            return price;
          }
        } catch (error) {
          console.error("Unable to parse variant data", error);
        }
      }
    }
    
    // Try to get from displayed price
    const priceElements = document.querySelectorAll(
      ".product-detail__price .card-product-price .price, .price-regular .price, .product-detail__price .price"
    );
    if (priceElements.length > 0) {
      const priceText = priceElements[0].textContent || "";
      // Match numbers with commas and decimals (e.g., "37,116.00", "37116", "Rs. 37,116.00")
      const priceMatch = priceText.match(/([\d,]+(?:\.\d+)?)/);
      if (priceMatch && priceMatch[1]) {
        const priceString = priceMatch[1].replace(/,/g, '');
        const price = parseFloat(priceString) * 100;
        if (price > 0) {
          console.log(`Base price from displayed price "${priceText}": ₹${(price / 100).toFixed(2)} (${price} cents)`);
          return price;
        }
      }
    }
    
    console.warn("ProductAccessoriesManager: Could not determine base price, using 0");
    return 0;
  }

  parsePriceFromText(text) {
    if (!text) return 0;
    // Match price patterns like: +₹3,711.60, + ₹3,711.60, ₹3,711.60, +3711.60, "22" Turban" +₹1,800.00
    // This regex handles comma-separated numbers and ignores quotes/other characters
    // Look for +₹ or ₹ followed by optional spaces and then digits with commas/decimals
    const priceMatch = text.match(/[+₹]\s*₹?\s*([\d,]+(?:\.\d+)?)/i);
    if (priceMatch && priceMatch[1]) {
      // Remove commas before parsing
      const priceString = priceMatch[1].replace(/,/g, '');
      const priceValue = parseFloat(priceString);
      if (!isNaN(priceValue) && priceValue > 0) {
        const priceInCents = Math.round(priceValue * 100);
        console.log(`Parsed price from "${text}": ₹${priceValue} (${priceInCents} cents)`);
        return priceInCents; // Convert to cents
      }
    }
    console.log(`No price found in "${text}", returning 0`);
    return 0; // Return 0 if no price found (for values like "40", "42", "44")
  }

  updatePrice() {
    let accessoryTotal = 0;
    const selectedAccessories = [];

    // Calculate price from checkboxes
    this.checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        const accessoryText = checkbox.dataset.accessoryText || checkbox.value;
        const price = this.parsePriceFromText(accessoryText);
        console.log(`Checkbox: "${accessoryText}" -> Price: ₹${(price / 100).toFixed(2)}`);
        accessoryTotal += price;
        selectedAccessories.push(accessoryText);
      }
    });

    // Calculate price from select dropdowns
    this.selects.forEach((select) => {
      const selectedOption = select.options[select.selectedIndex];
      if (selectedOption && selectedOption.value) {
        // Use textContent to get the full option text (includes price), fallback to data-accessory-text or value
        const accessoryText = selectedOption.textContent?.trim() || 
                             selectedOption.dataset.accessoryText || 
                             selectedOption.value;
        const price = this.parsePriceFromText(accessoryText);
        console.log(`Select "${select.name}": "${accessoryText}" -> Price: ₹${(price / 100).toFixed(2)}`);
        accessoryTotal += price;
        selectedAccessories.push(accessoryText);
      }
    });

    const totalPrice = this.basePrice + accessoryTotal;
    console.log(`Total calculation: Base ₹${(this.basePrice / 100).toFixed(2)} + Accessories ₹${(accessoryTotal / 100).toFixed(2)} = Total ₹${(totalPrice / 100).toFixed(2)}`);
    this.updatePriceDisplay(totalPrice);
  }

  updatePriceDisplay(totalPrice) {
    // Try multiple selectors to find price elements
    const selectors = [
      ".product-detail__price .card-product-price .price",
      ".product-detail__price .card-product-price",
      ".price-regular .price",
      ".product-detail__price .price",
      "[data-product-price] .price",
      ".product-single__price .price"
    ];
    
    let priceElements = [];
    for (const selector of selectors) {
      priceElements = document.querySelectorAll(selector);
      if (priceElements.length > 0) break;
    }
    
    const moneyFormat = window.themeGlobalVariables?.settings?.money_format || "{{amount}}";
    
    if (priceElements.length === 0) {
      console.warn("ProductAccessoriesManager: No price elements found");
      return;
    }
    
    priceElements.forEach((element) => {
      if (window.Shopify && window.Shopify.formatMoney) {
        element.textContent = window.Shopify.formatMoney(totalPrice, moneyFormat);
      } else {
        element.textContent = this.formatMoney(totalPrice);
      }
    });
    
    console.log(`Price updated: Base ₹${(this.basePrice / 100).toFixed(2)} + Accessories ₹${((totalPrice - this.basePrice) / 100).toFixed(2)} = Total ₹${(totalPrice / 100).toFixed(2)}`);
  }

  formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return `₹${amount}`;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const manager = new ProductAccessoriesManager();
  if (manager.accessoriesContainer) {
    manager.accessoriesContainer.manager = manager;
  }
});

